export default __webpack_public_path__ + "static/blog-thumbnail-16ec1a95913a8c4fa4426b967ec8a393.jpg";